import { query } from './query';
import store, { type FeaturesState } from './store';
import CRUDService from 'state/CRUDService';
import { type Feature } from 'types/models';

export default class FeaturesService extends CRUDService<FeaturesState> {
   constructor() {
      super('features', store, query);
   }

   async changeFeature(featureId: Feature['id'], changes: Partial<Feature>) {
      return this.httpClient
         .patch(`/${this.version}/${this.entityName}/${featureId}`, changes)
         .then((resp) => this.store.update(featureId, resp.data))
         .catch((error) => this.setError(error));
   }

   isFeatureActive(featureName: Feature['name']) {
      if (this.getLoading()) {
         return false;
      }

      return this.query.hasEntity(({ active, name }: Partial<Feature>) => name === featureName && active);
   }
}
